import axios from "axios";

const putForStartVideoCall = async (baseUrl, token, doctorId, appointmentId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/start", {id: 0}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                data: res.data.data,
                message: res.data.message
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return putResponse
}

export default putForStartVideoCall;